// extracted by mini-css-extract-plugin
export default {"btnTop":"styles_btnTop__UmPAI"};